import './Hero.css'

const Hero = ({ heroRef }) => {
    return (
        <section className='content-container hero' ref={heroRef}>
            <div className='hero-background'></div>
            <aside>
                <h2>Know which skus are really profitable<span>?</span></h2>
                <p>The ones that are most visible. With SkuProfit, manage your eCommerce business with the most granular, sku-level intelligence available. </p>
            </aside>
        </section>
    )
}

export default Hero;